import { apiClient } from '@/api/axios';
import type { ApiResponse } from '@/types/api';
import type {
  AppNotification,
  PaginatedNotifications,
  UnreadCountResponse,
} from '@/types/notification';

const NOTIFICATIONS_BASE = '/api/notifications';

export const notificationService = {
  async list(params: { page?: number; limit?: number; unreadOnly?: boolean } = {}): Promise<PaginatedNotifications> {
    const { data } = await apiClient.get<ApiResponse<PaginatedNotifications>>(NOTIFICATIONS_BASE, {
      params,
    });
    return data.data;
  },

  async getUnreadCount(): Promise<number> {
    const { data } = await apiClient.get<ApiResponse<UnreadCountResponse>>(
      `${NOTIFICATIONS_BASE}/unread-count`,
    );
    return data.data.unreadCount;
  },

  async markAsRead(id: string): Promise<AppNotification> {
    const { data } = await apiClient.put<ApiResponse<AppNotification>>(
      `${NOTIFICATIONS_BASE}/${id}/read`,
    );
    return data.data;
  },

  async markAllAsRead(): Promise<{ markedCount: number }> {
    const { data } = await apiClient.put<ApiResponse<{ markedCount: number }>>(
      `${NOTIFICATIONS_BASE}/read-all`,
    );
    return data.data;
  },
};
